export const FIRST_ORDER_LABELS = [
  "Kind",
  "Enkelkind",
  "Urenkel",
  "Ur-Urenkel",
  "Ur-Ur-Urenkel",
];

export const SECOND_ORDER_LABELS = [
  "Elternteil",
  "Geschwister",
  "Nichte oder Neffe",
  "Großnichte/Großneffe",
  "Urgroßnichte/Urgroßneffe",
  "Ur-Urgroßnichte/Ur-Urgroßneffe",
];
